<ng-container
  *ngIf="permissions.hasPermission(permission.Create, activity) | async"
>
  <button
    class="floatFab"
    mat-fab
    color="primary"
    matTooltip="Add Protected Resource"
    i18n-matTooltip
    (click)="addResource()"
  >
    <mat-icon>add</mat-icon>
  </button>
</ng-container>
<table
  mat-table
  [dataSource]="displayedResources!"
  matSort
  matSortActive="name"
  matSortDirection="asc"
>
  <ng-container matColumnDef="icon">
    <th mat-header-cell style="width: 15px" *matHeaderCellDef></th>
    <td
      mat-cell
      style="width: 15px"
      *matCellDef="let resource"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      <mat-icon
        [matTooltip]="getIconTooltip(resource)"
        [matBadge]="resource.enableLoginCache ? '!' : ''"
        matBadgeSize="small"
        matBadgeColor="accent"
        [color]="
          resource === highlightedResource
            ? 'primary'
            : resource.isEnabled
              ? ''
              : 'warn'
        "
        >{{
          resource.isEnabled ? 'verified_user' : 'remove_moderator'
        }}</mat-icon
      >
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th
      mat-header-cell
      mat-sort-header
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      Name
    </th>
    <td
      mat-cell
      *matCellDef="let resource"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      <span>{{ resource.name }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th
      mat-header-cell
      mat-sort-header
      fxHide.lt-md
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      Type
    </th>
    <td
      mat-cell
      *matCellDef="let resource"
      fxHide.lt-md
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      {{ mfa.getTypeName(resource!.type) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="created">
    <th
      mat-header-cell
      mat-sort-header
      fxHide.lt-md
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      Created
    </th>
    <td
      mat-cell
      fxHide.lt-md
      *matCellDef="let resource"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      {{ resource.created | date:'short' }}
    </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="users">
    <th
      mat-header-cell
      fxHide.lt-md
      *matHeaderCellDef
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
      i18n
    >
      Users
    </th>
    <td
      mat-cell
      fxHide.lt-md
      *matCellDef="let resource"
      [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
    >
      <a (click)="handleUsersClick(resource, $event)">
        <span>{{ resource.users }} </span>
        <span *ngIf="resource.users !== 0">{{
          resource.usersExpanded ? '-' : '+'
        }}</span></a
      >
      <div
        class="indented"
        [@detailExpand]="resource.usersExpanded ? 'expanded' : 'collapsed'"
      >
        <div *ngIf="resource.registered !== 0">
          <span i18n>Registered</span>: {{ resource.registered }}
        </div>
        <div *ngIf="resource.pending !== 0">
          <a (click)="handlePendingClick(resource, $event)">
            <span i18n>Pending:</span> {{ resource.pending }}
            <span>{{ resource.pendingExpanded ? '-' : '+' }}</span></a
          >
          <div
            class="indented"
            [@detailExpand]="
              resource.pendingExpanded ? 'expanded' : 'collapsed'
            "
          >
            <div *ngIf="resource.pendingNotSent !== 0">
              <span i18n>Not Sent</span>: {{ resource.pendingNotSent }}
            </div>
            <div *ngIf="resource.pendingQueued !== 0">
              <span i18n>Queued</span>: {{ resource.pendingQueued }}
            </div>
            <div *ngIf="resource.pendingFailure !== 0">
              <span i18n>Delivery Failed</span>: {{ resource.pendingFailure }}
            </div>
            <div *ngIf="resource.pendingSent !== 0">
              <span i18n>Sent</span>: {{ resource.pendingSent }}
            </div>
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <tr
    mat-header-row
    fxHide.lt-md
    *matHeaderRowDef="
      ['icon', 'name', 'type', 'created', 'users'];
      sticky: true
    "
  ></tr>
  <tr
    mat-row
    class="highlightRow"
    [routerLink]="[row.id]"
    *matRowDef="let row; columns: ['icon', 'name', 'type', 'created', 'users']"
    (mouseenter)="highlightedResource = row"
    (mouseleave)="highlightedResource = null"
  ></tr>
</table>
